import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { forWho, notForWho } from '../data/salesPage';
export function AudienceSection() {
  return <section aria-label="Para quién es" className="border-t border-ink-line bg-ink-raised" data-id="element-15" data-mp="n3kyl41qj4d3">
      <div className="mx-auto grid max-w-6xl gap-16 px-5 py-20 sm:py-28 lg:grid-cols-[1.3fr_1fr] lg:gap-20" data-id="element-16" data-mp="s1e1no7qri95">
        <div data-id="element-17" data-mp="wxl9jmjp73tq">
          <h2 className="font-display text-4xl font-black uppercase text-bone sm:text-5xl" data-id="element-18" data-mp="3vhbfq890xacr">
            ¿Para quién <span className="text-lime" data-id="element-19" data-mp="4b0adzwzdnfm">es?</span>
          </h2>
          <p className="mt-4 text-lg text-bone-muted" data-id="element-20" data-mp="4ba0rolxtwlu">Este programa puede ser para vos si:</p>
          <ul className="mt-8 space-y-4" data-id="element-21" data-mp="98imu0a7iksd">
            {forWho.map(item => <li key={item} className="flex items-start gap-3 text-lg text-bone" data-id="element-22" data-mp="e1v4fqggxrbm">
                <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-lime" strokeWidth={3} aria-hidden="true" data-id="element-23" data-mp="3crlkjk1cmmkb" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="lg:pt-2" data-id="element-24" data-mp="14bc4tckfc661">
          <h2 className="font-display text-3xl font-black uppercase text-bone-muted sm:text-4xl" data-id="element-25" data-mp="14aaujab8fnpd">¿Para quién no es?</h2>
          <p className="mt-4 text-lg text-bone-muted" data-id="element-26" data-mp="zdss4h3dk1g7">Este programa no es para vos si buscás:</p>
          <ul className="mt-8 space-y-4" data-id="element-27" data-mp="uiwn8gd1hjlo">
            {notForWho.map(item => <li key={item} className="flex items-start gap-3 text-lg text-bone-muted" data-id="element-28" data-mp="qiw80ti494dk">
                <XIcon className="mt-1 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-29" data-mp="ll46r8vl05wp" />
                {item}
              </li>)}
          </ul>
          <p className="mt-10 border-l-2 border-lime pl-5 font-display text-xl font-bold text-bone" data-id="element-30" data-mp="bldc9770tqwm">
            Si buscás una solución realista y estructurada, entonces sí.
          </p>
        </div>
      </div>
    </section>;
}